import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { MesnaZajednica } from './mesna-zajednica';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-mesna-zajednica-modal-update',
  templateUrl: './mesna-zajednica-modal-update.component.html'  
})
export class MesnaZajednicaModalUpdateComponent extends BaseModalUpdateComponent<MesnaZajednica> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<MesnaZajednica>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
